import {
    getNextUniqueKey,
    UpgradeLayoutOptions,
} from 'layout/upgrade/upgradeLayout';
import { WidgetType } from 'widgets/WidgetType';
import { CapsuleContainerWidgetConfigState } from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';
import cloneDeep from 'lodash/cloneDeep';
import flatten from 'lodash/flatten';

/*
 * Fix duplicated capsule keys in the layout https://jira.isn.instinet.com:8443/browse/IND2-2930
 */
export default function upgradeLayoutToVersion3(options: UpgradeLayoutOptions) {
    const { loggingService, components } = options;

    const capsuleContainerKeys = Object.keys(components).filter(
        (k) => components[k].type === WidgetType.TILES
    );

    const allCapsuleKeys = flatten(
        capsuleContainerKeys.map((c) =>
            (
                components[c] as unknown as CapsuleContainerWidgetConfigState
            ).tiles.map((t) => t.widgetKey)
        )
    );

    const capsuleKeys: string[] = [];

    for (const capsuleContainerKey of capsuleContainerKeys) {
        const ccConfig = components[
            capsuleContainerKey
        ] as unknown as CapsuleContainerWidgetConfigState;

        for (const capsule of ccConfig.tiles) {
            const isDuplicate = capsuleKeys.indexOf(capsule.widgetKey) > -1;

            if (isDuplicate) {
                const nextUniqueKey = getNextUniqueKey(
                    capsule.widgetType,
                    allCapsuleKeys
                );
                loggingService.warn(
                    'upgradeLayoutToVersion3',
                    `Replacing ${capsule.widgetKey} with ${nextUniqueKey} in ${capsuleContainerKey}`
                );

                if (components[capsule.widgetKey]) {
                    components[nextUniqueKey] = cloneDeep(
                        components[capsule.widgetKey]
                    );
                }
                capsule.widgetKey = nextUniqueKey;
                allCapsuleKeys.push(nextUniqueKey);

                options.layout.components.push({
                    id: nextUniqueKey,
                    type: capsule.widgetType,
                });
            }

            capsuleKeys.push(capsule.widgetKey);
        }
    }
}
